module.exports = __webpack_public_path__ + "static/img/1805_4.5a72a99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1805_4.jpg
// module id = M/X+
// module chunks = 1